import { useState } from 'react';

import { useResetDatagridAvailableColumns } from 'hooks/useResetDatagridAvailableColumns';
import enFlag from 'images/en.png';
import ruFlag from 'images/ru.png';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useLocale, useSetLocale } from 'react-admin';
import { IconButton } from 'shared/mui/IconButtons';
import { ListItemIcon, ListItemText } from 'shared/mui/List';
import { Menu } from 'shared/mui/Menu/Menu';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';

type LanguageSwitcherProps = {
  onLanguageChange?: (lang: 'ru' | 'en') => Promise<void> | void;
};

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ onLanguageChange }) => {
  const translate = useTypedTranslate();
  const locale = useLocale();
  const setLocale = useSetLocale();
  const resetDatagridAvailableColumns = useResetDatagridAvailableColumns();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleChangeLanguage = async (lang: 'ru' | 'en') => {
    try {
      if (onLanguageChange) {
        await onLanguageChange(lang);
      }

      setLocale(lang);
      resetDatagridAvailableColumns();
      handleClose();
    } catch (e: any) {
      console.error(e);
      handleClose();
    }
  };

  const flags: Record<string, string> = { en: enFlag, ru: ruFlag };
  const currentFlag = flags[locale] || ruFlag;

  return (
    <div>
      <IconButton color="inherit" onClick={handleClick} size="large" sx={{ padding: '8px' }}>
        <img alt="flag" height="24" src={currentFlag} width="24" />
      </IconButton>
      <Menu
        PaperProps={{ sx: { borderRadius: 2, minWidth: 150 } }}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        disableScrollLock
        onClose={handleClose}
        open={open}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={() => handleChangeLanguage('ru')}>
          <ListItemIcon>
            <img alt="ru" height="24" src={ruFlag} width="24" />
          </ListItemIcon>
          <ListItemText primary={translate('app.common.ru')} />
        </MenuItem>
        <MenuItem onClick={() => handleChangeLanguage('en')}>
          <ListItemIcon>
            <img alt="en" height="24" src={enFlag} width="24" />
          </ListItemIcon>
          <ListItemText primary={translate('app.common.en')} />
        </MenuItem>
      </Menu>
    </div>
  );
};
